<template>
  <Transition name="fade">
    <div v-if="isOpen" class="cookies-window">
      <div class="cookies-window__content">
        <UiText
          font="body-text-small"
          color="typography-body02"
          class="cookies-window__text"
        >
          {{ $t("cookiesWindow.text") }}
        </UiText>

        <UiLink
          :to="$paths.policy"
          color="green"
          class="cookies-window__link"
          :text="$t('cookiesWindow.link')"
        />
      </div>

      <UiBtn
        class="cookies-window__btn"
        :text="$t('cookiesWindow.btnText')"
        size="s"
        color="primary"
        @click="acceptCookies"
      />
    </div>
  </Transition>
</template>

<script>
import { storageService } from '@/services/index.js'

export default {
  name: 'CookiesWindow',
  data() {
    return {
      isOpen: false,
    }
  },
  mounted() {
    this.isOpen = !storageService.getStorage().isKey('allowedUseCookie')
  },
  methods: {
    acceptCookies() {
      if (!this.isOpen) return

      const expiryDate = new Date(new Date().getTime() + 315576000000) //  expiryDate + 10 years
      storageService.setItem('allowedUseCookie', '', expiryDate)
      this.isOpen = false
    },
  },
}
</script>

<style lang="scss" src="./style.scss"></style>
